import { laravelDataProvider } from '@bnb/ra-data-laravel';

export const dataProvider = laravelDataProvider({
    apiUrl: '/api',
});
